module.exports = __webpack_public_path__ + "img/15-02.0ad9b26d.png";